import React, {useCallback} from 'react'
import {Lang} from 'yougile-lang'
import {ContentTypeUtil} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {EventBus} from '@client/event-bus'
import {openInvitePopup} from '@client/events'
import {Sync} from '@client/sync'
import {MessageBox} from '@components/message-box'
import {usePreview} from '@components/right-panel/chat/chat-messages/message/utils/use-preview'
import {useChatStore} from '@components/right-panel/chat/chat-store'
import {ChatUtils} from '@extensions/chat-utils'

export const useMessageClick = (): ((e: React.MouseEvent) => void) => {
  const [, store] = useChatStore()
  const preview = usePreview()

  return useCallback(
    e => {
      const target = e.target as HTMLElement

      if (target?.nodeName === 'A') {
        const node = target as HTMLAnchorElement
        const selectedHref = node.pathname
        const extension = selectedHref.split('.')?.pop()?.split('?')[0]
        if (extension && ContentTypeUtil.isVideoExtension(extension)) {
          preview(selectedHref, e)
        }
      }

      if (target?.nodeName === 'IMG') {
        const parentNode = target.parentNode as HTMLAnchorElement
        const selectedHref = parentNode.pathname
        preview(selectedHref, e)
      }

      const box = Sync.getOrCurrent(store.state.hub)

      const dataset = target?.dataset
      if (dataset?.task) {
        const companyId = dataset.company as DataObjectId
        const b = (companyId ? Sync.get({companyId}) : undefined) ?? box
        const hub = b.getHub(dataset.task)
        if (!hub) {
          MessageBox.warn(Lang.msg.chat.taskNotFound)
          return
        }
        ChatUtils.openChat(hub)
      }

      if (dataset?.user) {
        const user = box.getUser(dataset.user)
        if (!user) {
          return
        }
        EventBus.dispatch(openInvitePopup(user))
      }
    },
    [store, preview]
  )
}
